@if (pending()) {
  <span
    class="inline-flex items-center rounded-md bg-[#ecdcc2] px-2 py-1 text-xs font-bold text-primary-500 whitespace-nowrap"
    >Pending</span
  >
}

@if (staged()) {
  <span
    class="inline-flex items-center rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-white whitespace-nowrap"
    >Coming Soon</span
  >
}

@if (certified()) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold backdrop-blur-[2px] text-primary-500 whitespace-nowrap"
    >Certified</span
  >
}

@if (turnkey()) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold backdrop-blur-[2px] text-primary-500 whitespace-nowrap"
    >Turn-key</span
  >
}

@if (furnished()) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold backdrop-blur-[2px] text-primary-500 whitespace-nowrap"
    >Furnished</span
  >
} @else if (partiallyFurnished()) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold backdrop-blur-[2px] text-primary-500 whitespace-nowrap"
    >Partially Furnished</span
  >
} @else if (furnitureAvailable()) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold backdrop-blur-[2px] text-primary-500 whitespace-nowrap"
    >Furniture Available Separately</span
  >
}
